import React, { useEffect, useState } from "react";
import SEO from "../../Common/SEO";
import CompanyPostContent from "./CompanyPostContent";
import CompanyPostCreate from "./CompanyPostCreate";
import CompanyPostEdit from "./CompanyPostEdit";
import "./style.scss";

const CompanyPosts = props => {
  const { companyData } = props;
  const [postsAction, setPostsAction] = useState("");
  const [isAccessMember, setIsAccessMember] = useState(false);
  const [seelctedPost, setSelectedPost] = useState("");

  useEffect(() => {
    setIsAccessMember(
      companyData?.isOwner || companyData?.isAdmin || companyData?.isMember
    );
  }, [companyData]);

  return (
    <React.Fragment>
      <SEO title={`${companyData?.orgName || "Profile"} | Posts | 6ix`} />
      <div className="event-page-company-posts">
        {postsAction === "create" && isAccessMember ? (
          <CompanyPostCreate
            orgId={companyData?.id}
            setPostsAction={setPostsAction}
          />
        ) : postsAction === "edit" && isAccessMember && seelctedPost?._id ? (
          <CompanyPostEdit
            orgId={companyData?.id}
            setPostsAction={setPostsAction}
            postId={seelctedPost?._id}
          />
        ) : (
          <CompanyPostContent
            companyData={companyData}
            setPostsAction={setPostsAction}
            isAccessMember={isAccessMember}
            orgId={companyData?.id}
            seelctedPost={seelctedPost}
            setSelectedPost={setSelectedPost}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CompanyPosts;
